import useTranslator from "@pma/hooks/use-translator"
import { Tooltip, TooltipContent, TooltipTrigger } from "../common/tooltip"
import { Button } from "../common/button"
import { MessageCircle } from "lucide-react"
import { DictType } from "@pma/types"

interface Props {
  file: DictType
  isMenuView?: boolean
}

const ShareFileOnWhatsApp = ({ file, isMenuView }: Props) => {
  const { translate } = useTranslator()

  const handleOnClick = () => {
    const url = file?.file
    if (url) {
      const message = `Check out this file: ${url}`
      const encodedMessage = encodeURIComponent(message)
      const appUrl = `whatsapp://send?text=${encodedMessage}`
      const webUrl = `https://wa.me/?text=${encodedMessage}`

      window.location.href = appUrl

      setTimeout(() => {
        const confirmFallback = window.confirm(
          "It looks like WhatsApp didn't open. Open WhatsApp Web instead?",
        )
        if (confirmFallback) {
          window.open(webUrl, "_blank")
        }
      }, 2000) // Delay is necessary to allow OS to react
    }
  }

  return isMenuView ? (
    <div className='flex items-center gap-2 rounded hover:bg-muted' onClick={handleOnClick}>
      <div className='px-2'>
        <MessageCircle className='' size={16} />
      </div>
      <span className='text-sm'>{translate("Share on WhatsApp")}</span>
    </div>
  ) : (
    <Tooltip>
      <TooltipTrigger>
        <Button
          size={"icon"}
          className='h-6 w-7'
          variant={"ghost"}
          aria-label={translate("Share on WhatsApp")}
          onClick={handleOnClick}
        >
          <MessageCircle size={14} />
        </Button>
      </TooltipTrigger>
      <TooltipContent>{translate("Share on WhatsApp")}</TooltipContent>
    </Tooltip>
  )
}

export default ShareFileOnWhatsApp
